<template>
  <div>
    <v-btn color="primary" dark class="mb-2 hbtn" to="/lost_and_found/store">{{ $t("complaintsPage.newBtn") }}</v-btn>
    <DataTable ref="reserDataTable" :disableSearch="true" :sortable="false" :url="'lost_and_found'" :titles="titles"
      :fields-hidden-main="['created_at', 'updated_at', 'deleted_at', 'captain_id']"
      :title="$t('complaintsPage.lostFoundTitle')" :enableEdit="false" :enableAdd="false" :enableDelete="false" :formatter="formatter"
      :actions-extra-main="actionsExtraMain" />
  </div>
</template>

<style>
.hbtn {
  float: inline-end;
  z-index: 1;
  margin-top: 20px;
  margin-inline-end: 20px;
  padding: 0px 45px;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";

export default {
  name: "Lost And Found",
  title() {
    return this.$t("complaintsPage.lostFoundTitle");
  },
  components: { DataTable },
  data() {
    return {};
  },

  computed: {
    rules() {
      const required = (val) =>
        (val !== null && val !== undefined) ||
        this.$t("complaintsPage.fieldRequired");
      return {
        name: [required],
      };
    },
    formatter() {
      const yes = this.$t("complaintsPage.yes");
      const no = this.$t("complaintsPage.no");
      return {
        found(value) {
          if (value) {
            return `<span style="color: green">${yes}</span>`;
          }
          return `<span style="color: red">${no}</span>`;
        }
      }
    },
    titles() {
      return {
        id: this.$t("complaintsPage.colId"),
        object: this.$t("complaintsPage.colObject"),
        day: this.$t("complaintsPage.colDay"),
        start_time: this.$t("complaintsPage.colStartTime"),
        end_time: this.$t("complaintsPage.colEndTime"),
        createdBy: this.$t("complaintsPage.colCreatedBy"),
        passenger_number: this.$t("complaintsPage.colPassengerNumber"),
        captain_username: this.$t("complaintsPage.colCaptain"),
        message: this.$t("complaintsPage.colMessage"),
        found: this.$t("complaintsPage.colFound"),
      };
    },
    actionsExtraMain() {
      return {
        edit: {
          title: this.$t("complaintsPage.edit"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "edit_lost_and_found",
              params: { id: item.id },
            }),
        },
        sendReminder: {
          title: this.$t("complaintsPage.sendReminder"),
          icon: "message",
          action: ({ id }) => {
            this.sendMessage(id)
          },
        },
        delete: {
          title: this.$t("complaintsPage.delete"),
          icon: "delete_forever",
          action: ({ id }) => {
            this.deleteLostAndFound(id)
          },
        },
      };
    },
  },
  methods: {
    deleteLostAndFound(id) {
      this.$dialova({
        title: this.$t("complaintsPage.deleteItemTitle", { id }),
        paragraph: this.$t("complaintsPage.deleteItemParagraph", { id }),
        loader: true,
      })
        .then(({ close }) => {

          this.axios
            .delete(`lost_and_found/${id}`)
            .then((res) => {
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("complaintsPage.deletedSuccessfully"),
                "green"
              );
              this.$refs.reserDataTable.getData();
            })
            .catch((err) => {
              let response = err.response;
              if (response) {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  response.data.message,
                  "red"
                );
              } else {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("complaintsPage.somethingWentWrong"),
                  "red"
                );
              }
            })
            .finally(() => (close()));
        })
        .catch(() => {
          console.log("cancelled");
        });
    },

    sendMessage(id) {
      this.$dialova({
        title: this.$t("complaintsPage.reminderTitle", { id }),
        paragraph: this.$t("complaintsPage.reminderParagraph", { id }),
        loader: true,
      })
        .then(({ close }) => {

          this.axios
            .post(`lost_and_found_message`,{id})
            .then((res) => {
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("complaintsPage.sentSuccessfully"),
                "green"
              );
            })
            .catch((err) => {
              let response = err.response;
              if (response) {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  response.data.message,
                  "red"
                );
              } else {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("complaintsPage.somethingWentWrong"),
                  "red"
                );
              }
            })
            .finally(() => (close()));
        })
        .catch(() => {
          console.log("cancelled");
        });
    },
  }
};
</script>
